import React, { useEffect } from 'react';
import useArticles from '../../Data/Article/useArticles';
import { getArticleUrl } from '../../helpers/articles';
import { getMarket } from '../../i18n';
import ArticleCard from '../../styled-components/components/ArticleCard';
import { readTime } from '../../utils/readTime';

interface ISelectedArticle {
  modelSeries: string;
}

const SelectedArticle = ({ modelSeries }: ISelectedArticle) => {
  const marketCode = getMarket().marketCode;
  const category = marketCode === 'NO' ? 'Biltester fra Broom TV2' : 'Välja bil';
  const [articleResponse, _, setSearchParams] = useArticles(
    new URLSearchParams(`categories=${category}&q=${modelSeries}`),
  );

  useEffect(() => {
    setSearchParams(new URLSearchParams(`categories=${category}&q=${modelSeries}`));
  }, [modelSeries]);

  if (
    !articleResponse ||
    articleResponse.response.documentList.documents.length === 0 ||
    articleResponse.response.documentList.documents[0].title.indexOf(modelSeries) < 0
  ) {
    return null;
  }

  const firstArticle = articleResponse.response.documentList.documents[0];

  return (
    <ArticleCard
      author={{
        name: firstArticle.author.fullName,
        image: `${firstArticle.author.profilePicture?.file.url}?w=32&h=32`,
        image2x: `${firstArticle.author.profilePicture?.file.url}?w=64&h=64 2x`,
      }}
      category={firstArticle.categories.map((cat) => cat.name).join(' / ')}
      date={firstArticle.publishDate}
      excerpt={firstArticle.excerpt}
      image={`${firstArticle.featuredMedia?.file.url}?w=867&h=503&q=60`}
      layout="large"
      link={getArticleUrl(firstArticle)}
      readTime={readTime(firstArticle.contentBlocks.join(' '))}
      title={firstArticle.title}
      videoIcon={!!firstArticle.videoUrl || !!firstArticle.bambuserVideo}
      backplate
    />
  );
};

export default SelectedArticle;
